<template>
  <b-modal @show="onShow" @hidden="onHidden" ref="modal-container" v-model="modalShow" size="lg"
    title="Edit operator in json data" :static="true" :lazy="true" hide-footer>
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group label="" label-for="json-input">
        <v-jsoneditor ref="settings-editor" v-model="operator"
          :options="{ mode: 'code', enableSort: false, enableTransform: false }" :plus="false"
          class="jsoneditor-container" />
        <!-- <b-form-input id="settings-editor-error" v-model="settingsEditorError" v-validate="{ is: '' }"
          :state="validateState('settings-editor-error')" aria-describedby="settings-editor-error"
          data-vv-name="settings-editor-error" data-vv-as="Value" hidden autocomplete="off" /> -->
        <b-form-invalid-feedback id="settings-editor-error" v-if="veeErrors.first('settings-editor-error')">
          {{ settingsEditorError }}
        </b-form-invalid-feedback>
      </b-form-group>
    </form>

    <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit"
      :disabled="this.saveInProgress || !this.$store.getters['partnersForSelect/loaded']">Save</b-button>
  </b-modal>
</template>

<script>
import { getRouteIcon, ROUTE_OPERATORS } from "../../utils/routerIcons";
import VJsoneditor from "v-jsoneditor/src/index";

export default {
  data() {
    return {
      operatorId: null,
      operator: {},
      modalShow: false,
      saveInProgress: false,
    }
  },
  components: {
    VJsoneditor,

  },
  props: {
  },
  methods: {
    onShow() {
      this.resetModal();
    },
    onHidden() {
      this.resetModal();
      this.$emit('hidden');
    },
    getInitialValues() {
      return {

      };
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }


      return null;
    },
    resetModal() {
      // this.setDefaults();
    },
    hideModal() {
      this.modalShow = false;
    },
    show(operator) {
      this.operator = [];
      this.operatorId = operator.id;

      this.$http.get('/api/v1/operators/json/' + this.operatorId).then(response => {
        this.operator = response.data;
      }).catch((err) => {
            this.$toastr.e(JSON.stringify(err.response.data.message));

            throw err;
          });

      this.saveInProgress = false;
      this.modalShow = true;
    },
    handleSubmit() {
      if (this.saveInProgress) {
        return;
      }

      for (let key of Object.keys(this.operator)) {
        if (typeof this.operator[key] === 'string') {
          this.operator[key] = this.operator[key].trim();
        }
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }


        this.saveInProgress = true;
        this
          .$http({
            url: '/api/v1/operators/json/' + this.operatorId,
            data: JSON.stringify(this.operator),
            method: 'POST',
            headers: { "Content-Type": "application/json" },
          })
          .then(() => {
            this.$emit('finish');
            this.hideModal();
            this.$toastr.i('Success');
          })
          .catch((err) => {
            this.$toastr.e(JSON.stringify(err.response.data.message));

            throw err;
          })
          .finally(() => {
            this.saveInProgress = false
          })
      });
    },

  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_OPERATORS),
  },
  async beforeMount() {
  },
  mounted() {

  },
}
</script>

<style scoped>
.jsoneditor-container {
  height: 600px;
}
</style>